import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';

const API_URL = process.env.API_URL;

export async function getListCLTV(filter) {
  const url = `${API_URL}/admin/statistic/ltv`;
  return axios({
    url,
    method: 'get',
    params: filter,
    headers: authHeader2()
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/cltv.js